import React from "react";
import { View, Image, Text, TouchableOpacity, Platform } from "react-native";
import StyleSheet from "react-native-media-query";

import { ScreenNameList } from "@lib/utilities/Constants";
import DeviceInfo from "react-native-device-info";
import Color from "../../assets/color/Color";
import {
  BACK_ICON,
  CROSS_ICON,
  DELETE_ACCOUNT_ICON,
  FAQ_ICON,
  MANAGE_ACCOUNT_ICON,
  NEXT_GRAY_ICON,
  RESET_PASSWORD_ICON,
  SIGNOUT_ICON,
} from "../../resources/IMAGES";
import { clearSessionAndLogout } from "@lib/utilities/AuthHelper";
import { useNavigation } from "@react-navigation/native";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppSelector } from "@lib";
import { theme } from "../../theme/theme";
import { COLORS } from "src/theme/constants";

const RightPanelCommonView = (props: any) => {
  const { ids, styles } = StyleSheet.create({
    backButton: {
      marginRight:theme.spacing.xxs,
    },
    manageAccountContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      flex: 1,
    },
    drawerContentContainer: {
      padding: 16,
      paddingTop: 0,
    },
    profileIconContainer: {
      flexDirection: "row",
      flex: 1,
      alignItems:"center",
    },
    resetPasswordItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "row",
    },
    listItem: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      flex: 1,
    },
    signOut: {
      width: 20,
      height: 20,
      marginRight: 12,
      position: "relative",
      resizeMode:"contain",
      top: 1,
    },
    resetPasswordText: {
      color: theme.colors.text.secondary,
      fontSize: 16,

      marginRight: 10,
      ...Platform.select({}),
      fontFamily: theme.fontFamily.robotoMedium,
    },
    userProfileIconContainer: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
    },
    nextImage: {
      width: 9,
      height: 16,
      marginRight: 12,
    },
    logoutItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "row",
    },
    itemsText: {
      color: theme.colors.text.error,
      fontSize: 16,

      marginRight: 10,
      ...Platform.select({}),
      fontFamily: theme.fontFamily.robotoMedium,
    },
    closePanel: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      top: 0,
    },
    profileSection: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      flex: 1,
      borderStyle: "solid",
      borderBottomColor: theme.colors.black + 50,
      paddingHorizontal: theme.spacing.lg,
      paddingTop: theme.spacing.xlg,
    },
    separator: {
      width: "100%",
      height: 1,
      backgroundColor: COLORS.gray[200],
      marginVertical: theme.margin.xlg,
    },
    backButtonIcon: {
      width: 14,
      height: 26,
    },
    userNameText: {
      color: "#000",
      fontSize: theme.fontsize.md,

      marginLeft: 12,
      display: "flex",
      flex: 1,
      maxWidth: "90%",
      fontFamily: theme.fontFamily.robotoMedium,
      ...Platform.select({
        ios: {
          width: "70%",
        },
        android: {
          width: "65%",
        },
        web: {
          width: "90%",
          fontWeight: theme.fontweight.medium as any,
        },
      }),
    },
    userProfileName: {
      width: 45,
      height: 45,
      borderRadius: 80,
      backgroundColor: theme.colors.secondary,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    crossIcon: {
      width: 20,
      height: 20,
      marginLeft: 12,
      "@media (min-width: 700px)": {
        // iPad Pro 9.7
        width: 18,
        height: 18,
      },
    },
    crossIconTouch: {
      width: 44,
      height: 44,
      alignItems: "center",
      justifyContent: "center",
    },
    profileName: {
      fontSize: 22,
      fontWeight: "600",
      fontFamily: theme.fontFamily.robotoMedium,
      color: theme.colors.white,
    },
    versionView: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      top: props.height - 150,
      alignSelf: "center",
    },
    versionText: {
      color: theme.colors.text.secondary,
      fontSize: 16,
      fontWeight: "400",
    },
    deleteAccountContainer: {
      display: "flex",
      flexDirection: "column",
    },
    deleteAccountText: {
      color: theme.colors.button.danger,
      fontSize: 16,
      ...Platform.select({}),
      fontFamily: theme.fontFamily.robotoMedium,
    },
    deleteButtonMargin: {
      marginTop: 10,
    },
    emailText: {
      marginTop: 0,
      fontSize: 14,
      color: theme.colors.text.secondary,
      opacity: 0.7,
      ...Platform.select({}),
      fontFamily: theme.fontFamily.robotoMedium,
    },
  });

  const navigation = useNavigation();
  const { logout } = useAuth0();
  const isConnected = useAppSelector(
    (state) => state?.userReducer?.isConnected,
  );
  return (
    <>
      <View style={[styles.closePanel]} dataSet={{ media: ids.closePanel }}>
        <View
          style={[styles.profileSection]}
          dataSet={{ media: ids.profileSection }}
        >
          {props.displayManageAccountView ? (
            <View style={styles.profileIconContainer}>
              <TouchableOpacity
                style={styles.backButton}
                onPress={() => {
                  props.setDisplayManageAccountView(false);
                }}
                testID="side-panel-back-button"
              >
                <Image
                  style={styles.backButtonIcon}
                  dataSet={{ media: ids.backButtonIcon }}
                  source={BACK_ICON}
                  testID="side-panel-back-icon"
                />
              </TouchableOpacity>
              <Text
                style={styles.userNameText}
                dataSet={{ media: ids.userNameText }}
                testID="side-panel-manage-account-label"
              >
                Manage Account
              </Text>
            </View>
          ) : (
            <View style={styles.userProfileIconContainer}>
              <View
                style={styles.userProfileName}
                dataSet={{ media: ids.userProfileName }}
                testID="side-panel-user-initials-container"
              >
                <Text
                  style={styles.profileName}
                  dataSet={{ media: ids.profileName }}
                  testID="side-panel-user-initials-label"
                >
                  {props.userCredential}
                </Text>
              </View>
              <Text
                style={styles.userNameText}
                dataSet={{ media: ids.userNameText }}
                testID="side-panel-user-name-label"
              >
                {props.userName}
              </Text>
            </View>
          )}

          <TouchableOpacity
            onPress={() => {
              props.closeRightPanel();
            }}
            style={styles.crossIconTouch}
            testID="side-panel-close-button"
          >
            <Image
              style={styles.crossIcon}
              dataSet={{ media: ids.crossIcon }}
              source={CROSS_ICON}
              testID="side-panel-close-icon-image"
            />
          </TouchableOpacity>
        </View>
      </View>
      <View style={styles.separator} />
      <View style={styles.drawerContentContainer}>
        {props.displayManageAccountView ? (
          <View
            style={styles.resetPasswordItem}
            dataSet={{ media: ids.resetPasswordItem }}
            testID="side-panel-delete-account-container"
          >
            <TouchableOpacity
              onPress={() => {
                props.moveToDeleteAccountScreen();
              }}
              style={styles.listItem}
              testID="side-panel-delete-account-button"
            >
              <Image
                style={[styles.signOut, styles.deleteButtonMargin]}
                source={DELETE_ACCOUNT_ICON}
                testID="side-panel-delete-account-icon"
              />
              <View
                style={styles.deleteAccountContainer}
                dataSet={{ media: ids.deleteAccountContainer }}
                testID="side-panel-delete-account-label-container"
              >
                <Text
                  style={styles.deleteAccountText}
                  dataSet={{ media: ids.deleteAccountText }}
                  testID="side-panel-delete-account-label"
                >
                  Delete Account
                </Text>
                <Text
                  style={styles.emailText}
                  dataSet={{ media: ids.emailText }}
                  testID="side-panel-user-email-label"
                >
                  {props.email}{" "}
                </Text>
              </View>
            </TouchableOpacity>
          </View>
        ) : (
          <>
            <View
              style={styles.resetPasswordItem}
              dataSet={{ media: ids.resetPasswordItem }}
            >
              <TouchableOpacity
                onPress={() => {
                  props.onManageAccountClick();
                }}
                style={styles.listItem}
                testID="side-panel-manage-account-container-button"
              >
                <Image
                  style={styles.signOut}
                  source={MANAGE_ACCOUNT_ICON}
                  testID="side-panel-manage-account-icon"
                />
                <View
                  style={styles.manageAccountContainer}
                  dataSet={{ media: ids.manageAccountContainer }}
                  testID="side-panel-manage-account-container"
                >
                  <Text
                    style={styles.resetPasswordText}
                    testID="side-panel-manage-account-label"
                  >
                    Manage Account
                  </Text>
                  <Image
                    style={styles.nextImage}
                    source={NEXT_GRAY_ICON}
                    testID="side-panel-next-icon-image"
                  />
                </View>
              </TouchableOpacity>
            </View>
            <View style={styles.separator} />
            <View
              style={styles.resetPasswordItem}
              dataSet={{ media: ids.resetPasswordItem }}
            >
              <TouchableOpacity
                onPress={() => {
                  props.onFaqPress();
                }}
                style={styles.listItem}
                testID="side-panel-manage-account-container-button"
              >
                <Image
                  style={styles.signOut}
                  source={FAQ_ICON}
                  testID="side-panel-manage-account-icon"
                />
                <View
                  style={styles.manageAccountContainer}
                  dataSet={{ media: ids.manageAccountContainer }}
                  testID="side-panel-manage-account-container"
                >
                  <Text
                    style={styles.resetPasswordText}
                    testID="side-panel-manage-account-label"
                  >
                    FAQs
                  </Text>
                  <Image
                    style={styles.nextImage}
                    source={NEXT_GRAY_ICON}
                    testID="side-panel-next-icon-image"
                  />
                </View>
              </TouchableOpacity>
            </View>
            {props.screenName != ScreenNameList.forgotPassword &&
              props.screenName != ScreenNameList.resetPassword && (
                <>
                  <View style={styles.separator} />
                  <View
                    style={styles.resetPasswordItem}
                    dataSet={{ media: ids.resetPasswordItem }}
                    testID="side-panel-reset-password-container"
                  >
                    <TouchableOpacity
                      onPress={() => {
                        props.moveToResetPasswordScreen();
                      }}
                      style={styles.listItem}
                      testID="side-panel-reset-password-button"
                    >
                      <Image
                        style={styles.signOut}
                        source={RESET_PASSWORD_ICON}
                        testID="side-panel-reset-password-icon"
                      />
                      <Text
                        style={styles.resetPasswordText}
                        testID="side-panel-reset-password-label"
                      >
                        Reset Password
                      </Text>
                    </TouchableOpacity>
                  </View>
                </>
              )}
            <View style={styles.separator} />
            <View
              style={styles.logoutItem}
              dataSet={{ media: ids.logoutItem }}
              testID="side-panel-sign-out-container"
            >
              <TouchableOpacity
                onPress={() => {
                  if (isConnected) {
                    clearSessionAndLogout(navigation, logout);
                  } else {
                    props.closeRightPanel();
                  }
                }}
                style={styles.listItem}
                testID="side-panel-sign-out-button"
              >
                <Image
                  style={styles.signOut}
                  source={SIGNOUT_ICON}
                  testID="side-panel-sign-out-icon"
                />
                <Text
                  style={styles.itemsText}
                  testID="side-panel-sign-out-label"
                >
                  Sign Out
                </Text>
              </TouchableOpacity>
            </View>
          </>
        )}
        {Platform.OS != "web" && (
          <View style={styles.versionView} dataSet={{ media: ids.versionView }}>
            <Text
              style={styles.versionText}
              dataSet={{ media: ids.versionText }}
            >
              Version {DeviceInfo.getVersion()}({DeviceInfo.getBuildNumber()})
            </Text>
          </View>
        )}
      </View>
    </>
  );
};

export default RightPanelCommonView;
